const TICK_MS = 16;
const LOCK_MS = 300;

export function preventScrollDuringToolbarClick(anchor: HTMLElement): void {
  const snapshots: { el: HTMLElement; top: number; left: number }[] = [];
  let current: HTMLElement | null = anchor;
  while (current && current !== document.body) {
    const { overflowY } = getComputedStyle(current);
    if (overflowY === 'auto' || overflowY === 'scroll') {
      snapshots.push({ el: current, top: current.scrollTop, left: current.scrollLeft });
    }
    current = current.parentElement;
  }
  if (!snapshots.length) return;

  const intervalId = window.setInterval(() => {
    snapshots.forEach(({ el, top, left }) => {
      if (el.scrollTop !== top) el.scrollTop = top;
      if (el.scrollLeft !== left) el.scrollLeft = left;
    });
  }, TICK_MS);
  window.setTimeout(() => window.clearInterval(intervalId), LOCK_MS);
}
